import { styled } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  borderBottom: `3px solid ${theme.palette.secondary.main}`,
  zIndex: 1000,
}))

export const TitleText = styled(Box)(() => ({
  fontSize: '22px',
  textTransform: 'uppercase',
}))

export const Pointer = styled(Box)(() => ({
  cursor: 'pointer',
}))
